<template>
    <div class="manage">
        <addIconToSecondLevelDetails :settings="addIconToSecondLevelSettings"
                                     v-if="addIconToSecondLevelSettings.show"></addIconToSecondLevelDetails>
        <customModalDialog :settings="deleteIconPopupSettings"></customModalDialog>
        <customModalError :settings="errorPopupSettings"></customModalError>
        <label>{{ translate('sldChooseAnIcon') }}</label>

        <div class="dropdown" :style="getSldIconDropdown(secLevelBlock.icon, secLevelBlock.hash)">
            <div class="dropdown__btn" @click="showDropdownWithIcons"></div>
            <div class="dropdown__wrapper" :class="{show: showDropdown}">
                <div class="relative__block">
                    <div class="dropdown__content">
                        <div class="dropdown__images" v-for="(item, index) in blockValues" :key="index">
                            <div class="dropdown__images_wrapper">
                                <div class="edit_icons">
                                    <img class="icons" v-on:click="setBlockData(item, secLevelBlock)"
                                         :src="getSldIcon(item.icon, item.hash)">
                                    <div class="icons__show">
                                        <img @click.prevent="deleteIconClick(item)" class="trash"
                                             src="@/assets/icons/ic_trash.svg" alt="">
                                        <img @click.prevent="editIconClick(item)" class="edit"
                                             src="@/assets/icons/ic_edit.svg" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="addIcon__wrapper">
                        <div class="addIcon__btn" @click="showAddIconPopup">
                            {{ translate('sldAddIcon') }}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import config from '@/api/config';
import addIconToSecondLevelDetails from "@/components/widgets/addIconToSecondLevelDetails";
import customModalDialog from "@/components/widgets/customModalDialog";
import customModalError from "@/components/widgets/customModalError";
import {mapActions, mapMutations} from "vuex";
import errorMixin from "../../mixins/errorMixin";
import $ from 'jquery'

export default {
    name: "b-dropdawnItem",
    mixins: [errorMixin],
    data() {
        return {
            addIconToSecondLevelSettings: {},
            deleteIconPopupSettings: {},
            errorPopupSettings: {},
            errorInfoPopupSettings: {},
            showDropdown: false,
            isHovering: false,
        }
    },
    components: {
        addIconToSecondLevelDetails,
        customModalDialog,
        customModalError,
    },
    props: ['secLevelBlock', 'blockValues'],
    computed: {},
    mounted() {
        $(document).on('mousedown', e => {
            if (this.showDropdown) {
                if (($(".dropdown__wrapper").has(e.target).length === 0 &&
                        e.target.className != 'dropdown__wrapper')){
                    this.showDropdown = false
                }
            }
        });
    },
    methods: {
        ...mapActions({
            deleteIcon: 'question/deleteIcon',
        }),
        ...mapMutations({
            setProgressBarTag: 'setProgressBarTag',
            setMessageModel: 'setMessageModel',
        }),
        setBlockData(selectedItem, block) {
            block.text = selectedItem.value == "no_icon" ? '' : selectedItem.text
            block.value = selectedItem.value
            block.icon = selectedItem.icon
            block.hash = selectedItem.hash
            this.showDropdown = false
        },
        getSldIconDropdown(icon, hash) {
            return {
                backgroundImage: 'url(' + this.getSldIcon(icon, hash) + ')',
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                display: "block",
                width: 70 + 'px' + '!important',
                height: 70 + 'px',
                marginLeft: 25 + 'px',
            }
        },
        getSldIcon(icon, hash) {
            return `${config.baseUrl}/api/sec-level-images/${icon}?time=${hash}`
        },
        showAddIconPopup() {
            this.addIconToSecondLevelSettings = {
                show: true,
                edit_mode: false,
                show_add_more_btn: true,
                onIconAddedHandler: this.onIconAdded,
                onIconAddedAndMore: this.onIconSaveAndAddMore,
                onCancelHandler: this.showDropdownOnClosePopup
            }
        },
        onIconSaveAndAddMore(newIcon) {
            this.pushIconToDropdown(newIcon)
            this.showDropdown = true
        },
        onIconAdded(newIcon) {
            this.pushIconToDropdown(newIcon)
            this.setBlockImage(newIcon)
            this.showDropdown = false
        },
        showDropdownOnClosePopup() {
            this.showDropdown = true
        },
        pushIconToDropdown(newIcon) {
            this.blockValues.push({
                icon: newIcon.tag,
                text: newIcon.default_text,
                value: newIcon.default_text,
                uid: newIcon.uid,
                hash: ""
            })
        },
        deleteIconClick(item) {
            this.deleteIconPopupSettings = {
                icon: 'close-circle-outline.svg',
                message: this.translate('sldAreYouSure'),
                onOkHandler: this.deleteImageAction.bind(null, item),
                onCancelHandler: this.showDropdownOnClosePopup,
                showCancelButton: true,
                okButtonText: this.translate('yes'),
                cancelButtonText: this.translate('no'),
            }
        },
        async deleteImageAction(image) {
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'delete icon'
                })
                const response = await this.deleteIcon(image.uid)
                let index = this.blockValues.findIndex(item => item === image)
                this.blockValues.splice(index, 1)
                this.showDropdown = true
            } catch (error) {
                if(error.data.error.code == 3000) {
                    this.showTagInUseError(error)
                } else {
                    this.showErrorModal(error.data.error.message)
                }
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'delete icon'
                })
            }
        },

        showTagInUseError(error) {
            var msg = ''
            if(error.data.places.length > 0) {
                var places = "Places:\n"
                error.data.places.forEach(place =>
                    places += `${place.id} - ${place.place_name}\n`
                )
                msg += '\n' + places
            }
            if(error.data.questions.length > 0) {
                var questions = "Questions:\n"
                error.data.questions.forEach(question =>
                    questions += `${question.id} (${question.place_id} - ${question.place_name})\n`
                )
                msg += '\n' + questions
            }

            this.errorPopupSettings = {
                icon: 'close-circle-outline.svg',
                title: this.translate('sldTagInUseErrorTitle'),
                message: msg,
                okButtonText: this.translate('ok'),
            }
        },
        editIconClick(item) {
            this.addIconToSecondLevelSettings = {
                show: true,
                icon_tag: item.icon,
                icon_default_text: item.text,
                edit_mode: true,
                show_add_more_btn: false,
                image_guid: item.uid,
                old_image: item,
                onEditIconHandler: this.onEditIcon,
                onCancelHandler: this.showDropdownOnClosePopup,
                errorHandler: this.editIconErrorHandler,
            }
        },
        editIconErrorHandler(error) {
            if(error.data.error.code == 3000) {
                this.showTagInUseError(error)
                return true
            } else {
                return false
            }
        },
        onEditIcon(oldIcon, newIcon) {
            let hash = new Date().getMilliseconds()
            oldIcon.icon = newIcon.tag
            oldIcon.text = newIcon.default_text
            oldIcon.value = newIcon.default_text
            oldIcon.uid = newIcon.uid
            oldIcon.hash = hash
            this.setBlockImage(newIcon, hash)
            this.showDropdown = true
        },
        setBlockImage(icon, hash) {
            this.secLevelBlock.icon = icon.tag
            this.secLevelBlock.text = icon.default_text
            this.secLevelBlock.value = icon.default_text
            this.secLevelBlock.hash = hash
        },

        showDropdownWithIcons() {
            this.showDropdown = !this.showDropdown
        },

    }
}
</script>

<style>
.verte__menu-origin--bottom {
    right: 20px !important;
}
</style>

<style scoped>
.dropdown {
    position: relative;
}

.dropdown__btn {
    content: '';
    background-image: url("~@/assets/icons/ic_kebab.svg") !important;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    position: relative;
    right: 0;
    left: 80px;
    top: 0;
    width: 25px !important;
    height: 25px !important;
    margin-right: 4px;
    cursor: pointer;
}

.dropdown__wrapper {
    display: none;
    min-width: 400px;
    max-width: 650px;
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;
    overflow-x: inherit;
    background: white;
    position: absolute;
    border: 1px solid;
    z-index: 99;
    border-radius: 6px;
}
.dropdown__wrapper::-webkit-scrollbar  {
    display: none;
}

.dropdown__wrapper.show {
    display: block;
}

.dropdown__images .icons {
    height: 58px;
    margin: 15px;
    cursor: pointer;
}
.dropdown__images {
    position: relative;
}

.dropdown__content {
    position: relative;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
}

.relative__block {
    position: relative;
}

.trash, .edit {
    position: absolute;
    top: 0;
    width: 20px;
    cursor: pointer;
}

.edit {
    margin-left: 50px;
}

.trash {
    margin-left: 32px;
}

.icons__show {
    display: none;
}

.edit_icons:hover > .icons__show {
    display: block;
}

.manage .dropdown-menu li > a {
    position: relative !important;

}

.iconsForEdit {
    position: absolute;
    top: 0;
    visibility: visible;
    padding-left: 20px;
}

.iconsForEdit img {
    width: 20px;
}

.manage .dropdown-menu li > a div {
    width: 20px;
    height: 20px;
}

.manage .dropdown-menu li > a span {
    padding-bottom: 55px;
    font-size: 13px;
    margin-left: 0;
}

.manage .dropdown-menu li:not(:last-child) a:active img {
    filter: inherit;
}

.dropdown-range label {
    position: relative;
    color: #6D6D6D;
    padding-left: 0;
    opacity: 0.8;
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    margin-bottom: 5px;
}

.manage {
    min-width: 160px;
}

.manage .dropdown-menu li {
    width: 90px;
    height: 90px;
}

.manage .dropdown button.btn:before {
    content: '';
    background-image: url("~@/assets/icons/smells.svg") !important;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    position: relative;
    left: 0;
    top: 0;
    bottom: 0;
    width: 25px !important;
    height: 25px !important;
    margin-right: 4px;
}

.no_icon {

}

.addIcon__btn {
    text-align: end;
    padding-right: 10px;
    padding-bottom: 10px;
}

.addIcon__wrapper {
    color: #0e76a8;
    cursor: pointer;
}
@media screen and (max-width: 426px) {
    .dropdown__wrapper {
        left: -80px;
        max-width: 400px;
        min-width: 345px;
    }
}
@media screen and (max-width: 376px) {
    .manage .dropdown button.btn:before {
        content: none;
    }
    .dropdown__wrapper {
        min-width: 324px;
        left: -90px;
    }

}

</style>
